import MenuContentHeader from './MenuContentHeader';

export default MenuContentHeader;
